import { ReactNode } from 'react'

type Props = {
  children?: ReactNode
  header?: ReactNode
  footer?: ReactNode
}

/**
 *  grid‑rows: auto | 1fr | auto
 *  – header / footer may be empty; we reserve the row with an invisible <span>
 */
export function FullPageCard({ header, children, footer }: Props) {
  return (
    <div className="grid min-h-screen grid-rows-[auto_1fr_auto] bg-gray-100">
      <header>{header}</header>

      <main className="grid place-items-center overflow-y-auto p-6 lg:p-8">
        {children && (
          <div className="w-full max-w-md rounded-lg bg-white p-12 shadow">{children}</div>
        )}
      </main>

      <footer>{footer}</footer>
    </div>
  )
}
